import { Popover } from "antd"
import CustomEditor from "components/Common/CustomEditor"
import LoadingButton from "components/Common/LoadingButton"
import React, { useEffect, useRef, useState } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { dynamic_fields, dynamic_fields_task } from "./dynamic_fields"
import { axiosbaseurl } from "configure"
import { setUpdatedData } from "helpers/data_setters"
import { usePermissionData } from "AppContext"
import Select from "react-select"
import { designation_options } from "constants/layout"
import { customStyles } from "helpers/select-styles"

const AddAutoEmail = ({
  show,
  setShow,
  settable_data,
  template_id,
  settemplate_id,
}) => {
  // const [fileName, setFileName] = useState("")
  // const [attachment, setAttachment] = useState(null)
  const [templateName, setTemplateName] = useState("")
  const [subject, setSubject] = useState("")
  const [relatedTo, setRelatedTo] = useState("")
  const [body, setBody] = useState("")
  const [relatedData, setRelatedData] = useState(null)
  const [service, setService] = useState(null)
  const [servicesOptions, setServicesOptions] = useState([])

  const [afterDays, setafterDays] = useState(null)

  const [loading, setLoading] = useState(false)
  const [dynamic, setDynamic] = useState(false)

  const emailTypeOptions = ["Normal", "Recurring", "Ad-hoc"]
  const [emailType, setEmailType] = useState(emailTypeOptions[0])

  const intervalDaysOptions = [1, 2, 3, 4, 5, 6, 7]
  const [intervalDays, setIntervalDays] = useState(null)
  const [appliedStatus, setAppliedStatus] = useState("Awaiting Client")

  const [related_options, setrelated_options] = useState([])
  const [sentTo, setSentTo] = useState([])

  const fileRef = useRef()

  const sentToOptions = [
    ...designation_options.slice(0, 4),
    { value: "To Client", label: "To Client" },
  ]

  const other_status = [
    {
      label: "Awaiting Client",
      value: "Awaiting Client",
    },
    // {
    //   label: "Awaiting HMRC",
    //   value: "Awaiting HMRC",
    // },
    {
      label: "Received",
      value: "Received",
    },
  ]

  const boolean_status = [
    {
      label: "Yes",
      value: "yes",
    },
    {
      label: "No",
      value: "no",
    },
  ]

  // permissions Access
  const { checkAccess } = usePermissionData()
  const module_id = 3

  const isReadOnly =
    checkAccess(module_id, "view") &&
    !checkAccess(module_id, "edit") &&
    template_id

  // getting data for dynamic dropdowns based on relatedTo field
  useEffect(() => {
    ;(async () => {
      if (relatedTo) {
        try {
          let options = []
          switch (relatedTo) {
            case "invoice":
              options = await getOptions("invoicing-method")
              options = options?.map(d => ({
                label: d.invoicingMethod,
                value: d.id,
              }))
              break
            case "client-status":
              options = await getOptions("client-status")
              options = options
                ?.slice()
                .sort((a, b) => a.statusName.localeCompare(b.statusName))
                ?.map(d => ({
                  label: d.statusName,
                  value: d.id,
                }))
              break
            case "task-status-period-end":
              options = await getOptions("status-master")
              options =
                options
                  ?.slice()
                  .sort((a, b) => a.statusName.localeCompare(b.statusName))
                  ?.map(d => ({
                    label: d.statusName,
                    value: d.id,
                  })) || []
              break
            case "task-status-due-date":
              options = await getOptions("status-master")
              options =
                options
                  ?.slice()
                  .sort((a, b) => a.statusName.localeCompare(b.statusName))
                  ?.map(d => ({
                    label: d.statusName,
                    value: d.id,
                  })) || []
              break
            case "utr-status":
              options = [...other_status]
              break
            case "cac-status":
              options = [...other_status]
              break
            case "national-insurance-status":
              options = [...other_status]
              break
            case "paye-status":
              options = [...other_status]
              break
            case "vat-status":
              options = [...other_status]
              break
            case "personal-code-status":
              options = [...other_status]
              break

            case "utr-applied":
              options = [...boolean_status]
              break
            case "cac-applied":
              options = [...boolean_status]
              break
            case "paye-applied":
              options = [...boolean_status]
              break
            case "vat-applied":
              options = [...boolean_status]
              break
            case "personal-code-applied":
              options = [...boolean_status]
              break

            case "utr-agent":
              options = [...boolean_status]
              break
            case "cac-agent":
              options = [...boolean_status]
              break
            case "paye-agent":
              options = [...boolean_status]
              break
            case "vat-agent":
              options = [...boolean_status]
              break

            default:
              options = []
          }
          setrelated_options(options)
        } catch (error) {
          console.log(error)
        }
      }
    })()
  }, [relatedTo])

  useEffect(() => {
    ;(async () => {
      const services = await getOptions("service-master")
      setServicesOptions(services)
    })()
  }, [])

  // getting dropdown options common function
  async function getOptions(api) {
    try {
      const response = await axiosbaseurl.get(`/${api}/active`)
      if (response.data.success) return response.data.data

      return false
    } catch (error) {
      console.log(error)
    }
  }

  // getting existing data to initial show
  useEffect(() => {
    const getTemplate = async () => {
      try {
        setLoading(true)
        const response = await axiosbaseurl.get(
          `/email-template/${template_id}`
        )

        if (response.data.success) {
          let {
            templateName,
            subject,
            relatedTo,
            emailStatus,
            body,
            deliveryType,
            followUpDays,
            serviceId,
            afterDays,
            sentTo,
            appliedStatus,
            // fileName,
          } = response.data.data

          setTemplateName(templateName)
          setSubject(subject)
          setRelatedTo(relatedTo)
          setRelatedData(emailStatus)
          setBody(body)
          setService(serviceId)
          setEmailType(deliveryType)
          setIntervalDays(followUpDays)
          setafterDays(afterDays)
          setAppliedStatus(appliedStatus)
          sentTo = JSON.parse(sentTo || "[]")

          setSentTo(sentToOptions.filter(item => sentTo?.includes(item.value)))
          // setFileName(fileName)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }

    if (template_id) getTemplate()
  }, [template_id])

  // reset states
  useEffect(() => {
    if (!show) {
      setTemplateName("")
      setSubject("")
      setRelatedTo("")
      setBody("")
      setRelatedData(null)
      setService(null)
      setIntervalDays(null)
      setafterDays(null)
      // setFileName("")
      setSentTo([])
      setAppliedStatus("Awaiting Client")

      if (fileRef.current) fileRef.current.value = ""

      if (template_id) settemplate_id(null)
    }
  }, [show])

  // Handle form submission
  const handleSubmit = async e => {
    e.preventDefault()

    if (body && sentTo.length) {
      try {
        setLoading(true)
        const formData = new FormData()
        formData.append("templateName", templateName)
        formData.append("relatedTo", relatedTo)
        formData.append("subject", subject)
        formData.append("body", body)
        formData.append("afterDays", afterDays || 0)
        formData.append("emailStatus", relatedData)
        formData.append("serviceId", service)
        formData.append("deliveryType", emailType)
        formData.append("followUpDays", intervalDays || 0)
        formData.append("appliedStatus", appliedStatus)
        formData.append(
          "sentTo",
          JSON.stringify(sentTo.map(item => item.value))
        )

        // if (fileName) formData.append("fileName", fileName)
        // if (attachment) formData.append("attachment", attachment)

        let response
        // edit note
        if (template_id)
          response = await axiosbaseurl.put(
            `/email-template/${template_id}`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          )
        else
          response = await axiosbaseurl.post(`/email-template`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })

        if (response.data.success) {
          settable_data(prev =>
            setUpdatedData(
              prev,
              response.data.data,
              template_id ? "edit" : "add"
            )
          )
          setShow(false)
        }
      } catch (error) {
        const msg =
          error.response.data.message || error.message || "Something went Wrong"
        swal(
          "",
          msg,
          msg.includes("No changes were made !") ? "warning" : "error"
        )
      } finally {
        setLoading(false)
      }
    } else {
      swal("All Fields required!")
    }
  }

  const triggerwithservice = [
    "invoice",
    "client-status",
    "task-status-period-end",
    "task-status-due-date",
  ]

  const triggerwithOtherStatus = [
    "utr-applied",
    "utr-agent",
    "cac-applied",
    "cac-agent",
    "paye-applied",
    "paye-agent",
    "vat-applied",
    "vat-agent",
    "personal-code-applied",
  ]

  return (
    <>
      <Modal
        size="xl"
        fullscreen
        isOpen={show}
        toggle={() => setShow(!show)}
        centered={true}
      >
        <form onSubmit={handleSubmit} className="modal-content">
          <ModalHeader className="w-100 bg-primary">
            <div className="d-flex align-items-center justify-content-between w-100 px-4">
              <h4 className="mb-0 text-white">
                {template_id ? (isReadOnly ? "View" : "Edit") : "Add"} Email
                Template
              </h4>
              <div>
                {!isReadOnly && <LoadingButton loading={loading} btn="light" />}
                <button
                  type="button"
                  className="btn btn-danger ms-3"
                  onClick={() => setShow(!show)}
                >
                  <i className="fa fa-times me-2"></i> Close
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody className="px-5 ">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label>
                    Email Type{" "}
                    {!isReadOnly && <span className="text-danger">*</span>}
                  </label>

                  <div className="row">
                    {emailTypeOptions.map(type => (
                      <div className="col-4" key={type}>
                        <label
                          htmlFor={type}
                          className={` px-3 mb-0 input-field w-100 border 
                                bg-${
                                  emailType === type
                                    ? "primary text-white"
                                    : "light"
                                }`}
                        >
                          <input
                            type="radio"
                            className="me-2"
                            disabled={isReadOnly}
                            checked={emailType === type}
                            onChange={() => {
                              setEmailType(type)

                              if (relatedTo) setRelatedTo("")
                              if (relatedData) setRelatedData(null)
                              if (service) setService(null)
                              if (intervalDays) setIntervalDays(null)
                              if (afterDays) setafterDays(null)
                            }}
                            name="emailType"
                            id={type}
                          />{" "}
                          <span>
                            {type === emailTypeOptions[0] ? "Scheduled" : type}
                          </span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label>
                  Sent To <span className="text-danger">*</span>
                </label>
                <Select
                  value={sentTo}
                  onChange={e => setSentTo(e)}
                  options={sentToOptions}
                  styles={customStyles}
                  isMulti
                />

                {/* <span className="error">{errors.designation}</span> */}
              </div>
            </div>
            <div className="row">
              {emailType !== emailTypeOptions[2] ? (
                <>
                  {emailType === emailTypeOptions[0] ? (
                    <div className="col-md-2">
                      <div className="mb-3">
                        <label>
                          Days after{" "}
                          {!isReadOnly && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <input
                          type="number"
                          disabled={isReadOnly}
                          placeholder="eg. 3"
                          value={afterDays}
                          onChange={e => setafterDays(e.target.value)}
                          className="form-control input-field"
                          required
                          min="1"
                        />
                      </div>
                    </div>
                  ) : null}

                  {emailType === emailTypeOptions[1] ? (
                    <div className="col-md-2">
                      <div className="mb-3">
                        <label>
                          Interval days{" "}
                          {!isReadOnly && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <select
                          disabled={isReadOnly}
                          value={intervalDays}
                          onChange={e => {
                            setIntervalDays(e.target.value)
                          }}
                          className="form-select input-field status_select_dropdown"
                          required
                        >
                          <option value="">Select interval</option>
                          {intervalDaysOptions.map(d => (
                            <option key={d} value={d}>
                              {d}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  ) : null}

                  <div className="col-md-10">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label>
                            Trigger{" "}
                            {!isReadOnly && (
                              <span className="text-danger">*</span>
                            )}
                          </label>
                          <select
                            disabled={isReadOnly}
                            value={relatedTo}
                            onChange={e => {
                              setRelatedTo(e.target.value)
                              setRelatedData(null)
                              setService(null)
                            }}
                            className="form-select input-field status_select_dropdown"
                            required
                          >
                            <option value="">Select trigger</option>
                            <option value="cac-applied">CAC Applied</option>
                            <option value="cac-status">CAC Status</option>
                            {/* <option value="cac-agent"> CAC Agent Authorisation Applied</option> */}

                            <option value="client-status">Client Status</option>

                            <option value="invoice">Invoice</option>

                            <option value="national-insurance-status">
                              National Insurance Status
                            </option>

                            <option value="paye-applied">PAYE Applied</option>
                            <option value="paye-status">PAYE Status</option>
                            <option value="paye-agent">
                              {" "}
                              PAYE Agent Authorisation Applied
                            </option>

                            <option value="personal-code-applied">
                              Personal Code Applied
                            </option>
                            <option value="personal-code-status">
                              Personal Code Status
                            </option>

                            <option value="task-status-due-date">
                              Task Status - Due Date
                            </option>
                            <option value="task-status-period-end">
                              Task Status - Period End
                            </option>

                            <option value="utr-applied">UTR Applied</option>
                            <option value="utr-status">UTR Status</option>
                            <option value="utr-agent">
                              {" "}
                              UTR Agent Authorisation Applied
                            </option>

                            <option value="vat-applied">VAT Applied</option>
                            <option value="vat-status">VAT Status</option>
                            <option value="vat-agent">
                              {" "}
                              VAT Agent Authorisation Applied
                            </option>
                          </select>
                        </div>
                      </div>

                      {relatedTo && (
                        <>
                          {triggerwithservice.includes(relatedTo) ? (
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label>
                                  Service{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <select
                                  disabled={isReadOnly}
                                  value={service}
                                  onChange={e => {
                                    setService(e.target.value)
                                  }}
                                  className="form-select input-field status_select_dropdown"
                                  required
                                >
                                  <option value="">Select service</option>
                                  {servicesOptions
                                    ?.slice()
                                    .sort((a, b) =>
                                      a.serviceName.localeCompare(b.serviceName)
                                    )
                                    ?.map(s => (
                                      <option key={s.id} value={s.id}>
                                        {s.serviceName}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                          ) : null}

                          {triggerwithOtherStatus.includes(relatedTo) ? (
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label className="text-capitalize">
                                  {relatedTo?.split("-")[0]} Status
                                  <span className="text-danger"> *</span>
                                </label>
                                <select
                                  disabled={isReadOnly}
                                  value={appliedStatus}
                                  onChange={e =>
                                    setAppliedStatus(e.target.value)
                                  }
                                  className="form-select input-field status_select_dropdown"
                                  required
                                >
                                  <option value="">Select Status</option>
                                  {other_status?.map(option => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          ) : null}

                          {related_options.length ? (
                            <div className="col-md-4">
                              <div className="mb-3">
                                <label className="text-capitalize">
                                  {relatedTo?.split("-")?.join(" ")}
                                  {[
                                    "utr-agent",
                                    "cac-agent",
                                    "paye-agent",
                                    "vat-agent",
                                  ].includes(relatedTo)
                                    ? " authorization applied status"
                                    : null}
                                  {[
                                    "utr-applied",
                                    "cac-applied",
                                    "paye-applied",
                                    "vat-applied",
                                  ].includes(relatedTo)
                                    ? " status"
                                    : null}
                                  {relatedTo === "invoice" ? " Method" : null}
                                  <span className="text-danger"> *</span>
                                </label>
                                <select
                                  disabled={isReadOnly}
                                  value={relatedData}
                                  onChange={e => setRelatedData(e.target.value)}
                                  className="form-select input-field status_select_dropdown"
                                  required
                                >
                                  <option value="">
                                    Select
                                    {relatedTo === "invoice"
                                      ? " Method"
                                      : " Status"}
                                  </option>
                                  {related_options?.map(option => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          ) : null}
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : null}

              <div className="col-12 border mb-4 mt-3"></div>

              <div className="col-md-4">
                <div className="mb-3">
                  <label>
                    Template Name{" "}
                    {!isReadOnly && <span className="text-danger">*</span>}
                  </label>
                  <input
                    type="text"
                    placeholder="Enter template name "
                    disabled={isReadOnly}
                    value={templateName}
                    onChange={e => setTemplateName(e.target.value)}
                    className="form-control input-field"
                    required
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label>
                    Subject{" "}
                    {!isReadOnly && <span className="text-danger">*</span>}
                  </label>
                  <input
                    type="text"
                    disabled={isReadOnly}
                    placeholder="Enter subject "
                    value={subject}
                    onChange={e => setSubject(e.target.value)}
                    className="form-control input-field"
                    required
                  />
                </div>
              </div>

              {!isReadOnly && (
                <div className="col-md-2">
                  <div className="mb-3">
                    <label>
                      Dynamic Fields{" "}
                      {!isReadOnly && <span className="text-danger">*</span>}
                    </label>
                    <div>
                      <button
                        type="button"
                        onClick={() => setDynamic(prev => !prev)}
                        style={{ height: "43px" }}
                        className="btn btn-primary rounded-0 w-100"
                      >
                        <i className="fas fa-list me-2"></i> Choose Fields{" "}
                        <i className="fas fa-angle-down ms-3"></i>
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* <div className="col-md-6">
                <div className="mb-3">
                  <label> Upload Attachment</label>
                  {fileName && <span className="text-primary ms-2">({fileName})</span>}
                  <input
                    type="file"
                    disabled={isReadOnly}
                    ref={fileRef}
                    onChange={e => {
                      const uploadedFile = e.target.files[0]
                      if (
                        uploadedFile &&
                        uploadedFile.type !== "application/pdf"
                      ) {
                        swal("", "Only PDF files are allowed !", "warning")
                        e.target.value = ""
                        return
                      }
                      setAttachment(uploadedFile)
                      setFileName(uploadedFile.name || "")
                    }}
                    className="form-control input-field" 
                    accept="application/pdf"
                  />
                </div>
              </div>

              {
                fileName &&
                <div className="col-md-6">
                  <div className="mb-3">
                    <label>Attachment Name</label>
                    <input
                      type="text"
                      placeholder="Enter file name "
                      disabled={isReadOnly}
                      value={fileName}
                      onChange={e => setFileName(e.target.value)}
                      className="form-control input-field" 
                    />
                  </div>
                </div>
              } */}

              <div className="col-md-12 mb-4">
                <label>
                  Body {!isReadOnly && <span className="text-danger">*</span>}
                </label>
                <CustomEditor
                  content={body}
                  setContent={setBody}
                  height={500}
                />
              </div>
            </div>
          </ModalBody>
        </form>
      </Modal>

      {/* Dynamic fields */}
      <Modal
        size="xl"
        isOpen={dynamic}
        toggle={() => setDynamic(!dynamic)}
        centered={true}
      >
        <div className="modal-content">
          <ModalHeader className="w-100 bg-primary">
            <div className="d-flex align-items-center justify-content-between w-100 px-2">
              <h4 className="mb-0 text-white">Click to Copy Dynamic field</h4>
              <div>
                <button
                  type="button"
                  className="btn btn-danger ms-3"
                  onClick={() => setDynamic(!show)}
                >
                  <i className="fa fa-times me-2"></i> Close
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <div>
              {(relatedTo === "task-status-period-end" ||
                relatedTo === "task-status-due-date") && (
                <div>
                  <h5 className="ms-4 mb-2">Task Fields</h5>
                  <div className="d-flex flex-wrap mb-4 px-3 border-bottom pb-4">
                    {dynamic_fields_task.map((item, i) => (
                      <CopyField key={i} name={item} />
                    ))}
                  </div>
                </div>
              )}
              <div>
                <h5 className="ms-4 mb-2">Client Fields</h5>
                <div
                  className="d-flex flex-wrap mb-2 px-3"
                  style={{
                    height: "450px",
                    overflow: "auto",
                    scrollbarWidth: "thin",
                  }}
                >
                  {dynamic_fields.map((item, i) => (
                    <CopyField key={i} name={item} />
                  ))}
                </div>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  )
}

function CopyField({ name }) {
  const [copySuccess, setCopySuccess] = useState(false) // State to track copy success

  const handleCopy = text => {
    // Use the Clipboard API to copy text
    navigator.clipboard
      .writeText(text)
      .then(() => {
        // Successfully copied
        setCopySuccess(true)

        // Optionally, reset the success state after a short delay
        setTimeout(() => {
          setCopySuccess(false)
        }, 2000) // Reset after 2 seconds
      })
      .catch(err => {
        console.error("Failed to copy: ", err)
        setCopySuccess(false)
      })
  }

  return (
    <div
      style={{ flexBasis: "33.33%", cursor: "pointer" }}
      title={copySuccess ? "Copied!" : "click to copy"}
      onClick={() => handleCopy(name)}
      className="py-2 px-2 border-bottom border-start d-flex justify-content-between align-items-center copy_field"
    >
      <span>{name}</span>
      <button type="button" className="btn btn-sm">
        <i
          className={`fas fa-${copySuccess ? "check text-primary" : "copy"}`}
        ></i>
      </button>
    </div>
  )
}

export default AddAutoEmail
